<template>
    <div>
        <el-form>
            <el-form-item label="下載目前設定檔">
                <el-button type="primary" @click="handle_config_download">下載</el-button>
            </el-form-item>
            <el-form-item label="上傳設定檔">
                <el-upload
                  class="upload-file"
                  action=""
                  :http-request="(file) => handle_config_upload(file)" 
                  :show-file-list="false"
                >
                  <el-button slot="trigger" type="primary">選擇檔案</el-button>
                  <span slot="tip" class="el-upload__tip">(檔案格式為標準JSON)</span>
                </el-upload>
            </el-form-item> 
        </el-form>
        <LoadingBlock
            :active="loading">
        </LoadingBlock>
    </div>
</template>

<script>
import LoadingBlock from '@/components/backstage/LoadingBlock/LoadingBlock.vue'
import api from '@/api/index'

export default {
    components: {
        LoadingBlock
    },
    data () {
        return {
            loading: false
        }
    },
    created () {
        
        if (this.account_info.email !== 'blueplanet@demo.com') {
            this.$router.push({path: '/backstage'})
            return
        }
    },
    methods: {
        async handle_config_download () {
            console.log('site-admin: config download')

            this.loading = true
            let res = await api.download_site_config()
            if (res.success === true){
                this.notify_message(this.ERROR.LEVEL.SUCCESS, '下載範本成功')
            }
            else {
                this.notify_message(this.ERROR.LEVEL.ERROR, '下載範本失敗', res.message)
            }
            this.loading = false

        },
        async handle_config_upload (file) {
            console.log('site-admin: config upload. file=', file)

            this.loading = true
            let res = await api.upload_site_config(file)
            if (res.success) {
                this.notify_message(this.ERROR.LEVEL.SUCCESS, '上傳成功', res.message)
            }
            else {
                this.notify_message(this.ERROR.LEVEL.ERROR, '上傳失敗', res.message)
            }
            this.loading = false
        },
    }
}
</script>

<style scoped>

</style>


